import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { CircleCheck, ArrowRight } from "lucide-react";
export default function ThePrimeGenMission() {
  return <section data-section-id="4278" id="decades-of-master-craftsmanship" className="bg-background text-foreground py-20 lg:py-32 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[var(--color-border)] to-transparent opacity-20" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[var(--color-border)] to-transparent opacity-20" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className="relative group">
            <div className="absolute -inset-4 bg-[var(--color-ring)]/10 rounded-xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            <div className="relative rounded-sm overflow-hidden border border-[var(--color-border)] shadow-2xl">
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent z-10" />
              <img src="/img/craftsman-deck-detail.jpg" alt="Expert deck builder detailing a high-quality Trex joint installation" className="w-full h-full object-cover min-h-[400px] lg:min-h-[600px] transform transition-transform duration-700 group-hover:scale-105" />
              
              {}
              <div className="absolute bottom-0 left-0 p-8 z-20 w-full">
                <div className="flex items-center gap-4 mb-2">
                  <div className="h-px w-12 bg-[var(--color-ring)]" />
                  <span className="text-[var(--color-ring)] font-default font-medium tracking-widest uppercase text-sm">
                    Bay Area Heritage
                  </span>
                </div>
                <p className="text-white/90 font-default font-light text-lg">
                  Serving Santa Clara to Monterey County
                </p>
              </div>
            </div>
            
            {}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 border-r-2 border-b-2 border-[var(--color-ring)]/30 hidden lg:block" />
            <div className="absolute -top-6 -left-6 w-24 h-24 border-l-2 border-t-2 border-[var(--color-ring)]/30 hidden lg:block" />
          </div>

          {}
          <div className="flex flex-col space-y-8">
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <span className="h-1 w-12 bg-[var(--color-ring)] rounded-full" />
                <span className="text-[var(--color-ring)] font-mono font-bold tracking-wider uppercase text-sm">
                  Since 1990
                </span>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold tracking-tight text-foreground leading-[1.1]">
                Mastery in Every <span className="text-[var(--color-ring)]">Grain.</span>
              </h1>
            </div>

            <div className="space-y-6 text-lg text-muted-foreground leading-[1.8] font-default">
              <p>
                Since 1990, PCH Builders has been the gold standard for deck construction across Northern California. As a licensed general contractor, we bring over three decades of engineering precision and architectural vision to every outdoor living space we craft.
              </p>
              <p>
                From the rugged coastlines of Monterey to the modern estates of Santa Clara, our legacy is built on structural integrity and premium materials. We specialize in Trex and composite decking, ensuring your investment withstands the California elements while elevating your home&apos;s aesthetic.
              </p>
              <p>
                Reliability is our foundation. We are fully licensed, insured, and dedicated to a seamless renovation experience. When you partner with PCH Builders, you are choosing thirty years of proven craftsmanship and a commitment to excellence that lasts a lifetime.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              {["Licensed & Insured #589211", "Serving 4 Major Counties", "Trex Platinum Pro Installers", "30+ Years Local Legacy"].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                  <CircleCheck className="w-5 h-5 text-[var(--color-ring)] shrink-0" />
                  <span className="text-foreground/90 font-default font-medium">{item}</span>
                </div>)}
            </div>

            <div className="pt-8 flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-[var(--color-ring)] hover:bg-[var(--color-ring)]/90 text-white border-none text-base px-8 h-14 rounded-[2px]">
                <Link to="#">
                  Get a Free Estimate
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-foreground/20 text-foreground hover:bg-foreground/5 text-base px-8 h-14 rounded-[2px]">
                <Link to="#">
                  View Our Portfolio
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}